// @flow

import React from "react";

export function MaxDesc(props: {
    shortName: string,
    showPersonalAccount: boolean,
    personaAccountBulletPoints: string[],
    showMaxAccount: boolean,
    maxAccountBulletPoints: string[]
}) {
    return (
        <div className="member-benefits-more">
            {props.showPersonalAccount && (
                <h5 className="member-benefits-more__header">
                    {props.shortName} Personal Account:
                    <br />
                    (for non-trade account holders)
                </h5>
            )}
            {props.showPersonalAccount && (
                <ul>
                    {props.personaAccountBulletPoints.map(b => (
                        <li key={b} dangerouslySetInnerHTML={{ __html: b }} />
                    ))}
                </ul>
            )}
            {props.showPersonalAccount && (
                <hr className="visible-sm visible-xs" />
            )}
            {props.showMaxAccount && (
                <h5 className="member-benefits-more__header">
                    maX - Your online business management system:
                    <br />
                    (for existing trade account holders)
                </h5>
            )}
            {props.showMaxAccount && (
                <ul>
                    {props.maxAccountBulletPoints.map(b => (
                        <li key={b} dangerouslySetInnerHTML={{ __html: b }} />
                    ))}
                </ul>
            )}
        </div>
    );
}
